<p class="text-center ">
  <video id="videos" [src]="videourl" type="video/mp4" class="col-12 col-md-10 col-lg-9" autoplay loop alt="Page Not Found" muted
    preload="metadata"></video>
</p>